import styled from 'styled-components'

export const Link = styled.a(({ theme }) => ({
	color: theme.colors.main,
}))
